import ProductItem from './ProductItem';
import { ProductItemProps, ProductItemValueProps } from './types';

export type { ProductItemProps, ProductItemValueProps };
export default ProductItem;
